import React from 'react';
import styled from 'styled-components';
import { Image, Icon, Loading } from '../';

const StyledAvatar = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 8px;
  position: relative;
  overflow: auto;
`;

type Props = {
  src: string,
  className: string,
  hasRemove?: Boolean,
  onClickRemove?: Function,
  loading?: Boolean,
};

export default function Avatar({
  src,
  className,
  hasRemove,
  onClickRemove,
  loading = false,
  onDragStart,
  draggable
}: Props) {
  return (
    <StyledAvatar draggable={draggable} onDragStart={onDragStart}>
      <Loading loading={loading} inside>
        <Image
          src={src}
          className={`img-fluid h-100 radius-md object-fit-cover ${
            className || ''
          }`}
        />
        {hasRemove ? (
          <Icon
            name="e-remove"
            color="white"
            className="bg-Primary hover-bg-red cursor-pointer rounded-circle p-1 position-absolute top-0 left-0 m-0 font-xsm"
            onClick={onClickRemove}
          />
        ) : null}
      </Loading>
    </StyledAvatar>
  );
}
